import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { base_url } from "../../utils/utils";

export const getProviders = createAsyncThunk("provider", async (id) => {
  const body = new FormData();
  body.append("action", "list");
  // body.append("userid", 1);
  const response = await fetch(base_url + "api/provider.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  return res;
});

const providerSlice = createSlice({
  name: "provider",
  initialState: {
    provider_list: [],
    p_loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getProviders.pending, (state, action) => {
      state.p_loading = true;
    });
    builder.addCase(getProviders.rejected, (state, action) => {
      state.p_loading = false;
    });
    builder.addCase(getProviders.fulfilled, (state, action) => {
      const data = action.payload;
      state.p_loading = false;
      if (data.success) {
        state.provider_list = data.message;
      } else {
        state.provider_list = [];
      }
    });
  },
});

export default providerSlice.reducer;
